import getStore from '../store/store';
import { userDate } from 'owa-datetime/lib/userDate';
import { mutator } from 'satcheljs';
import setEndDate from '../../actions/setEndDate';
import { getEndDate, getStartDate } from '../../selectors/getStoreProperties';
import getEndDateAfterModifications from '../../utils/getEndDateAfterModifications';

/**
 * Function to mutate the end date.
 */
export default mutator(setEndDate, ({ date }) => {
    let optionState = getStore().currentState;

    let curEnd = getEndDate();
    let endHours = curEnd.getHours();
    let endMinutes = curEnd.getMinutes();
    // Get the new end date values
    let newEndYear = date.getFullYear();
    let newEndMonth = date.getMonth();
    let newEndDate = date.getDate();
    // Set new end
    let newEnd = userDate(newEndYear, newEndMonth, newEndDate, endHours, endMinutes);
    optionState.endDate = newEnd;

    let startDate = getStartDate();
    optionState.startDate = userDate(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        startDate.getHours(),
        startDate.getMinutes()
    );

    optionState.endDate = getEndDateAfterModifications();
});
